/**
 *
 * @typedef {{
 *   id: string,
 *   name: string,
 * }} CategorySummary
 *
 * @typedef {{
 *   categories: CategorySummary[],
 *   tagTypes: string[],
 *   minPrice: number,
 *   maxPrice: number,
 * }} HighBallFilters
 *
 * @typedef {{
 *   id: string,
 *   name: string,
 *   type: string,
 *   createdAt: Timestamp,
 *   updatedAt: Timestamp,
 * }} Meta
 *
 */

import { path, prop } from 'ramda';
import { urls } from '../config';
import withAxios from '../utils/with-axios';
var filters = function filters(axios, taxonomyIds) {
  /** I'd rather do this through passing params, but axios serialises arrays like
   *    ?taxonomyId[0]=ABC&taxonomyId[1]=XYZ
   * where we just want
   *    ?taxonomyId=ABC&taxonomyId=XYZ
   */
  var queryString = taxonomyIds.reduce(function (q, id) {
    return "".concat(q, "taxonomyIds=").concat(id, "&");
  }, '?');
  return axios.get(urls.apiV3("/highball/filters".concat(queryString.substring(0, queryString.length - 1)))).then(prop('data'));
};
var meta = function meta(axios, clientId) {
  return axios.post(urls.apiV3("/highball/meta/searches"), {
    filter: {
      clientId: clientId
    }
  }).then(path(['data', 'data']));
};
export default {
  /**
   * Fetch filters for one or more taxonomies
   *
   * @param {Object} [optional] $axios Axios instance.
   * @param {String[]} taxonomyIds
   *
   * @returns {Promise<HighBallFilters>} Unresolved Promise from the API.
   */
  filters: withAxios(filters),
  /**
   *
   * @param {Object} [optional] $axios
   * @param {string[]} clientId
   *
   * @returns {Promise<{data: Meta[]}>} Unresolved Promise from the API.
   */
  meta: withAxios(meta)
};